var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticStyle: { display: "flex", "flex-direction": "column" } },
      [
        _c(
          "el-steps",
          { attrs: { active: _vm.active, simple: "" } },
          [
            _c(
              "el-step",
              {
                attrs: {
                  title: _vm.$t("Insurance.ChooseServiceProvider"),
                  icon: "1"
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "title" }, slot: "title" },
                  [
                    _vm.active === 2 && _vm.nowUuid && _vm.sourceFrom !== "page"
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "-100px" },
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.backPageHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.GoBack")))]
                        )
                      : _vm._e(),
                    _vm.active === 2 && _vm.nowUuid && _vm.sourceFrom === "page"
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "-100px" },
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.backHomePageHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.ReturnToHomepage")))]
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "index",
                        staticStyle: { "padding-left": "100px" }
                      },
                      [_vm._v("1")]
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Insurance.ChooseServiceProvider")))
                    ])
                  ],
                  1
                )
              ]
            ),
            _c(
              "el-step",
              {
                attrs: {
                  title: _vm.$t("Insurance.PurchaseInsurance"),
                  icon: "2"
                }
              },
              [
                _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                  _c("span", { staticClass: "index" }, [_vm._v("2")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Insurance.PurchaseInsurance")))
                  ])
                ])
              ]
            ),
            _c(
              "el-step",
              {
                attrs: {
                  title: _vm.$t("Insurance.ViewInsurancePolicy"),
                  icon: "3"
                }
              },
              [
                _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                  _c("span", { staticClass: "index" }, [_vm._v("3")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Insurance.ViewInsurancePolicy")))
                  ])
                ])
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active === 1,
            expression: "active === 1"
          }
        ],
        staticStyle: { "flex-grow": "1", display: "flex", overflow: "auto" }
      },
      [
        _c("policy-home-page", {
          ref: "policyHomePage",
          attrs: {
            "source-from": _vm.sourceFrom,
            "insure-form": _vm.insureForm
          },
          on: { insureSuccess: _vm.insureSuccess }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active === 2,
            expression: "active === 2"
          }
        ],
        staticStyle: { "flex-grow": "1", display: "flex" }
      },
      [
        _c("insure-iframe", {
          ref: "insureIframe",
          attrs: { "jump-url": _vm.jumpUrl }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }